var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, override } from 'mobx';
import { MultipleChoiceLegacy } from '../../MultipleChoice/modules/MultipleChoiceLegacy';
export class AssociateLegacy extends MultipleChoiceLegacy {
    constructor(parent) {
        super(parent);
        makeObservable(this);
    }
    get question() {
        return this.questionTypeStore.question;
    }
    get legacyImagePlaces() {
        return [
            ['correctComment', this.question.ownAspect.commentCorrect],
            ['generalComment', this.question.ownAspect.comment],
            ['question', this.questionPart.inner],
            ['text1', this.allOptions[0].inner],
            ['text2', this.allOptions[1].inner],
            ['text3', this.allOptions[2].inner],
            ['text4', this.allOptions[3].inner],
            ['text5', this.allOptions[4].inner],
            ['text6', this.allOptions[5].inner],
            ['text7', this.allOptions[6].inner],
            ['text8', this.allOptions[7].inner],
            ['text9', this.allOptions[8].inner],
            ['wrongComment', this.question.ownAspect.commentWrong],
        ];
    }
    get legacyCommentPlaces() {
        return [
            ['correct', this.question.ownAspect.commentCorrect],
            ['general', this.question.ownAspect.comment],
            ['wrong', this.question.ownAspect.commentWrong],
        ];
    }
    /*
    get additionalLegacyComments() {
      return this.question.allAssociations
        .filter(associate => !!associate.inner.local.traitOf.text)
        .map(associate => ({
          id: associate.associateLegacyId,
          question_id: this.question.id,
          place: associate.place,
          comment: associate.inner.local.traitOf.text.local.valueOf.textBasis,
        }));
    } */
    /*
    get additionalLegacyImages() {
      return this.question.allAssociations
        .filter(associate => associate.inner.local.has.image && associate.inner.local.ensuredTraitOf.image.essence.local.has.imageFile)
        .map(associateWithImage => {
          const img = associateWithImage.inner.local.ensuredTraitOf.image.essence.local.ensuredTraitOf.imageFile.value;
          if (!img) return undefined;
          const legacyImage = img.imgLegacy.toLegacy(`${associateWithImage.place}Comment`);
          if (!legacyImage) return undefined;
          return legacyImage;
        })
        .filter(i => !!i) as LegacyImage[];
    }
  */
    realizeUnmatchedLegacyComments(legacyCommentRows) {
        this.realizeAssociateTextsFromLegacyComments(legacyCommentRows.filter(row => row.place.startsWith('field') && row.comment.length > 0));
    }
    realizeAssociateTextsFromLegacyComments(legacyCommentRows) {
        const associates = legacyCommentRows.map(legacyCommentRow => this.realizeAssociateTextFromLegacyComment(legacyCommentRow));
        const additional = associates.filter(a => !this.question.allAssociations.includes(a));
        this.question.allAssociations.push(...additional);
    }
    realizeAssociateTextFromLegacyComment(legacyCommentRow) {
        const associate = this.question.associateItems.getEnsuredAssociationByPlace(legacyCommentRow.place);
        associate.inner.aspectContent.local.primaryTextBasis = legacyCommentRow.comment;
        associate.associateLegacyId = legacyCommentRow.id;
        return associate;
    }
    realizeUnmatchedLegacyImages(legacyImageRows) {
        this.realizeAssociateImagesFromLegacyImages(legacyImageRows.filter(row => row.place.endsWith('Comment')));
    }
    realizeAssociateImagesFromLegacyImages(legacyImageRows) {
        const associatesWithImages = legacyImageRows.map(legacyCommentRow => this.realizeAssociateImageFromLegacyImage(legacyCommentRow));
        const associateWithoutImages = this.question.allAssociations.filter(x => !associatesWithImages.includes(x));
        associateWithoutImages.forEach(associateWithoutImage => {
            if (associateWithoutImage.inner.local.traitOf.image) {
                associateWithoutImage.inner.local.ensuredTraitOf.image.traitEdit.remove();
            }
        });
    }
    realizeAssociateImageFromLegacyImage(legacyImageRow) {
        const associatePlace = legacyImageRow.place.split('Comment')[0];
        const associate = this.question.associateItems.getEnsuredAssociationByPlace(associatePlace);
        this.setLegacyImageToAspect(legacyImageRow, associate.inner);
        return associate;
    }
}
__decorate([
    override
], AssociateLegacy.prototype, "legacyImagePlaces", null);
__decorate([
    override
], AssociateLegacy.prototype, "legacyCommentPlaces", null);
